/**
 * 新增 or 编辑
 */
import { Cascader, Form, Input, Select, Spin, TreeSelect, Divider, Tree} from 'antd'
import { useEffect, useState } from 'react'
import { STriggerModal } from 'shj-components'
import {getTagTreeByType} from "@/services/customerServices";
const { Search } = Input;
const ModalAddOrEditDom = (props: any) => {
  const { fn, rest, open, onClose } = props
  const [form] = Form.useForm()
  const [submitLoading, setSubmitLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [tagsMap, setTagsMap] = useState(new Map());
  const [tagTypeTree, setTagTypeTree] = useState([]);
  const id = rest?.id

  // 提交
  const onFinish = () => {
    
  }
  const onSearch = () => {
    console.log(tagsMap,'sss')
    console.log(tagTypeTree,'sss1')
    
  }
  const getLabelTree = () => {
    getTagTreeByType('custom').then((res: Record<string, any>) => {
      const {records} = res;
      const tagList = [];
      delTree(records, tagList);
      delTags(tagList);
      setTagTypeTree(records)
    })
  }
// 取出所有标签数据
const delTree = (data = [], tagsList: any[] = []) => {
  return data.reduce((res: any[], item: Record<string, any>): any => {
    if (item.object.groupTag === 'tag') {
      tagsList.push(item)
    } else {
      if (item.children) {
        const res = delTree(item.children, tagsList);
        if (res) item.children = res; else delete item.children
      }
      res.push(item)
      return res;
    }
  }, [])
};
// 整合标签数据为map对象
const delTags = (data: any[]) => {
  const tagsMap = new Map();
  data.forEach((tag: any) => {
    if (tagsMap.has(tag.object.pid)) {
      tagsMap.set(tag.object.pid, [...tagsMap.get(tag.object.pid), tag])
    } else {
      tagsMap.set(tag.object.pid, [tag])
    }
  })
  setTagsMap(tagsMap);
}
  useEffect(() => {
    getLabelTree()
  }, [])
  return (
    <STriggerModal
      width={800}
      title={'选择标签'}
      open={open}
      cancelText="取消"
      okText="确定"
      onOk={onFinish}
      onCancel={onClose}
      confirmLoading={submitLoading}
    >
      <Spin spinning={loading}>
        <Search placeholder="输入标签名称进行搜索" onSearch={onSearch} style={{ width: 300 }} />
        <Divider></Divider>
        <div style={{display:'flex', height: '100%'}}>
          <Tree
            fieldNames={{
              title: 'label',
              key: 'id',
            }}
            treeData={tagTypeTree}
          />
        </div>
        
      </Spin>
    </STriggerModal>
  )
}
export default ModalAddOrEditDom
